import React from "react";

import {
  Col,
  Row,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faSpinner } from "@fortawesome/free-solid-svg-icons";

const Header = ({ searchText, onSearchTextChange, onSearchClick, loading }) => {
  return (
    <Row className="mb-2 mb-xl-4">
      <Col xs="auto">
        <Breadcrumb>
          <BreadcrumbItem>Admin</BreadcrumbItem>

          <BreadcrumbItem active>Manage Spam Emails</BreadcrumbItem>
        </Breadcrumb>
      </Col>

      <Col xs="auto" className="ml-auto text-right mt-n1">
        <InputGroup className="mb-3">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <FontAwesomeIcon icon={faSearch} className="mr-2" />
              Search Email
            </InputGroupText>
          </InputGroupAddon>
          <Input
            placeholder="Email address"
            name="searchEmailAddress"
            value={searchText}
            onChange={onSearchTextChange}
            style={{ width: "250px" }}
          />{" "}
          <Button
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onSearchClick(e);
            }}
            disabled={loading}
          >
            Search
            {loading && <FontAwesomeIcon icon={faSpinner} className="ml-2" spin />}
          </Button>
        </InputGroup>
      </Col>
    </Row>
  );
};

export default Header;
